/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Mode de saisie d'une franchise ou d'un plafond.
 * @export
 */
export const TypeBorne = {
    Slider: 1,
    List: 2
} as const;
export type TypeBorne = typeof TypeBorne[keyof typeof TypeBorne];


export function instanceOfTypeBorne(value: any): boolean {
    for (const key in TypeBorne) {
        if (Object.prototype.hasOwnProperty.call(TypeBorne, key)) {
            if (TypeBorne[key as keyof typeof TypeBorne] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TypeBorneFromJSON(json: any): TypeBorne {
    return TypeBorneFromJSONTyped(json, false);
}

export function TypeBorneFromJSONTyped(json: any, ignoreDiscriminator: boolean): TypeBorne {
    return json as TypeBorne;
}

export function TypeBorneToJSON(value?: TypeBorne | null): any {
    return value as any;
}

export function TypeBorneToJSONTyped(value: any, ignoreDiscriminator: boolean): TypeBorne {
    return value as TypeBorne;
}

